import { render, staticRenderFns } from "./FormConsulta.vue?vue&type=template&id=12e36c84&scoped=true"
import script from "./FormConsulta.vue?vue&type=script&lang=js"
export * from "./FormConsulta.vue?vue&type=script&lang=js"
import style0 from "./FormConsulta.vue?vue&type=style&index=0&id=12e36c84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e36c84",
  null
  
)

export default component.exports